<template>
  <div :class="'md-layout'">
    <div :class="'md-layout-item md-size-66 md-xsmall-size-80 mx-auto text-center'" v-if="isFetching">
      <span :class="'md-title'">Loading review details...</span>
      <md-progress-spinner :class="'md-accent md-flex text-center'" :md-stroke="3" md-mode="indeterminate">
      </md-progress-spinner>
    </div>
    <div :class="'md-layout-item md-size-66 md-xsmall-size-80 mx-auto'" v-else>
      <simple-wizard>
        <template slot="header">
          <span :class="'md-body-2'">Created at: <span :class="'md-body-1'">{{ rqr.created_at | date }}</span></span>
        </template>
        <wizard-tab>
          <template slot="label">
            Administrative Information
          </template>
          <first-step :users="users" :clusters="clusters" :arrs="arrs" :fetchedARQR="rqr" mode="viewing"
            :disabled="areFieldsDisabled" :isSaving="isSavingARQ" :canEdit="canEdit" ref="firstStep"></first-step>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('secondStep')">
          <template slot="label">
            Engagement Information
          </template>
          <second-step :fetchedARQR="rqr" mode="viewing" :isSaving="isSavingARQ" :canEdit="canEdit"
            @validate="onStepValidated" ref="secondStep"></second-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>

<script>
import { date } from '@/filters'
import { SimpleWizard, WizardTab } from '@/components'
import { SlideYDownTransition } from 'vue2-transitions'
import FirstStep from './Create/FirstStep.vue'
import SecondStep from './Create/SecondStep.vue'
import { camelToSnake } from "@/methods/api/requests"

export default {
  components: {
    SlideYDownTransition,
    SimpleWizard,
    WizardTab,
    FirstStep,
    SecondStep,
  },

  filters: {
    date,
  },

  data() {
    return {
      users: [],
      clusters: [],
      arrs: [],

      rqr: {},

      isFetching: false,

      isSavingARQ: false,
      errorResponses: {
        422: 'There is an error with the RQR',
      },

      areFieldsDisabled: true,
    }
  },

  computed: {
    canEdit() {
      return this.rqr.status < 10 && (this.$route.params['viewPermission'] === null || this.$route.params['viewPermission'] === undefined ? true : this.$route.params['viewPermission'])
    }
  },

  methods: {
    validateStep(ref) {
      if (this.isSavingARQ) {
        return false
      }

      return this.$refs[ref].validate()
    },

    onStepValidated(validated) {
      if (!validated) {
        return
      }

      this.isSavingARQ = true

      if (this.rqr.status === 10) {
        this.$router.push({ name: 'Reviews', params: { id: 1 } })

        return
      }

      const updatedARQR = Object.assign({}, this.rqr)

      this.$api.request.put(`reviews/${this.rqr.id}`, updatedARQR)
        .then(() => {
          this.$toast.show('RQR successfully edited', '')
          this.$router.push({ name: "Reviews", params: { id: 1 } });
        })
        .catch(error => {
          if (this.errorResponses[error.response.status]) {
            this.$toast.show(this.errorResponses[error.response.status])
          } else {
            this.$toast.show('Ops, something went wrong! Please, try again.')
          }
        })
        .finally(() => {
          this.isSavingARQ = false
        })
    },

    finishView() {
      this.$router.push({ name: 'Reviews', params: { id: 1 } })
    },

    getARQR() {
      this.isFetching = true

      this.$api.request(`reviews/${this.$route.params['id']}?users=all`)
        .then(response => {
          this.isFetching = false

          this.$nextTick(() => {
            this.rqr = camelToSnake(response.data[0])
          })
        })
    },
    getUsers() {
      this.$api.request('all/users')
        .then(response => {
          this.users = camelToSnake(response.data).filter(d => d.inactive_user === null)
        })
    },

    getClusters() {
      this.$api.request("all/clusters").then((response) => {
        this.clusters = camelToSnake(response.data);
      });
    },
    getAdvisories() {
      this.$api.request('all/advisories')
        .then(response => {
          this.arrs = camelToSnake(response.data)
        })
    },
  },

  created() {
    this.getARQR()
    this.getUsers()
    this.getClusters();

    if (this.$route.name !== 'Review Details') {
      this.getAdvisories()
    }
  },
}
</script>
